import documentsAPI from '../api'

const headers = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
}

export async function getReports({ page = 1, pageSize = 10 } = {}) {
	const { data } = await documentsAPI.post(`/reports/list`, {
		page,
		page_size: pageSize,
	})

	return data
}

export async function reprocessReport(reportId) {
	const { data } = await documentsAPI.post(`/reports/reprocess/${reportId}`, {
		headers,
	})

	return data
}

export async function checkReportStatus(reportId) {
	const { data } = await documentsAPI.get(
		`/reports/check-batch-status/${reportId}`,
		{ headers }
	)

	return data
}

export async function createReportIntent({ reportType, filters = {} } = {}) {
	const { data } = await documentsAPI.post(
		`/reports/create-report-intent`,
		{ report_type: reportType, filters },
		{ headers }
	)

	return data
}
